import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const StyledLink = styled.a`
  display: flex;
  height: 44px;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    height: 60px;
  }

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
